import React from 'react';
import Api from '../../../js/Api';
import Utilities from '../../../js/Utilities';
import ReportsHeader from '../../Common/ReportsHeader/ReportsHeader';
import Loader from '../../Common/Loader/Loader';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import './MangoPickleStock.css';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';

const Client = new Api();
const moment = require('moment-timezone');
const FIXED_ITEM_NAME = 'Mango Pickle';
const BRANCH_STORAGE_KEY = 'mangoPickleStockSelectedBranch';
const ALL_BRANCH_OPTION = { name: 'All Branches', value: '' };
const SKU_USAGE_KG = {
  'Mango Summer': 0.12,
  'Mango Matcha': 0.11,
  'Mango Passion Iced Tea': 0.08
};

class MangoPickleStock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      saving: false,
      recordsLoading: false,
      branches: [],
      selectedBranch: '',
      stockDate: moment.tz(moment(), 'Asia/Kolkata').format('YYYY-MM-DD'),
      openingStock: '',
      closingStock: '',
      unit: 'kg',
      records: [],
      editingRecordId: null,
      analyticsLoading: false,
      exportLoading: false,
      salesAnalyticsRows: [],
      formWarning: ''
    };
  }

  loadBranches = async () => {
    const db = firebase.firestore();
    const branchesSnapshot = await db.collection('branches').get();
    const branches = [];

    branchesSnapshot.forEach((doc) => {
      const data = doc.data();
      if (!data.branchName) {
        return;
      }

      let displayName;
      let branchValue;
      if (data.branchName === 'Got Tea - Deer Park') {
        displayName = 'Safdarjung (GOT-001)';
        branchValue = 'Safdarjung';
      } else if (data.branchName === 'Got Tea - GK2') {
        displayName = 'GK2 (GOT-003)';
        branchValue = 'GreaterKailash2';
      } else if (data.branchName === 'Got Tea - Galleria') {
        displayName = 'Galleria (GOT-004)';
        branchValue = 'Galleria';
      } else {
        displayName = data.branchName.replace(/^Got Tea - /i, '').trim() + ` (${data.branchCode || 'GOT-000'})`;
        branchValue = data.branchName;
      }

      branches.push({
        name: displayName,
        value: branchValue
      });
    });

    branches.sort((a, b) => a.name.localeCompare(b.name));
    return branches;
  };

  getStoredBranch = (branches) => {
    const storedBranch = localStorage.getItem(BRANCH_STORAGE_KEY) || '';
    if (!storedBranch) return '';
    return branches.some((branch) => branch.value === storedBranch) ? storedBranch : '';
  };

  loadRecords = async () => {
    this.setState({ recordsLoading: true });
    try {
      const records = await Client.searchActions('', { actionType: ['mangoPickleStockEntry'] });
      const activeRecords = (records || []).filter((record) => record.status !== 'Deleted');
      this.setState({ records: activeRecords, recordsLoading: false }, () => {
        this.prefillExistingEntry();
      });
    } catch (error) {
      console.error('Failed to load mango pickle records', error);
      this.setState({ recordsLoading: false });
    }
  };

  deleteRecord = async (record) => {
    const shouldDelete = window.confirm('Delete this entry?');
    if (!shouldDelete) return;

    this.setState({ recordsLoading: true });
    try {
      await Client.updateAction(record.id, {
        actionType: 'mangoPickleStockEntry',
        status: 'Deleted'
      });
      await this.loadRecords();
      await this.loadSalesAnalytics(this.state.stockDate);
      if (this.state.editingRecordId === record.id) {
        this.resetForm();
      }
    } catch (error) {
      console.error('Failed to delete entry', error);
      alert('Could not delete entry. Please try again.');
      this.setState({ recordsLoading: false });
    }
  };

  getStartAndEndTime = (dateString) => {
    const startTime = moment(dateString).add(6, 'hours').valueOf();
    const endTime = moment(dateString).add(1, 'days').add(6, 'hours').valueOf();
    return { startTime, endTime };
  };

  getNormalizedSkuName = (itemName) => {
    const raw = (itemName || '').toLowerCase().trim();
    if (raw === 'mango summer') return 'Mango Summer';
    if (raw === 'mango matcha') return 'Mango Matcha';
    if (raw === 'mango passion iced tea' || raw === 'mango iced tea') return 'Mango Passion Iced Tea';
    return null;
  };

  getSoldDrinkQuantity = (item) => {
    return parseInt(item['Item Count'], 10) || 0;
  };

  getDisplayDateFromOrderItem = (item, fallbackDate) => {
    const dateCandidates = [
      item?.orderTimestamp,
      item?.OrderTimestamp,
      item?.createdAt,
      item?.CreatedAt,
      item?.date,
      item?.Date
    ];

    for (const candidate of dateCandidates) {
      if (candidate === undefined || candidate === null) continue;
      if (typeof candidate === 'number') {
        const parsed = moment(candidate);
        if (parsed.isValid()) return parsed.tz('Asia/Kolkata').format('YYYY-MM-DD');
      }
      if (typeof candidate === 'string' && candidate.trim()) {
        const parsed = moment(candidate);
        if (parsed.isValid()) return parsed.tz('Asia/Kolkata').format('YYYY-MM-DD');
      }
      if (candidate?.seconds) {
        const parsed = moment(candidate.seconds * 1000);
        if (parsed.isValid()) return parsed.tz('Asia/Kolkata').format('YYYY-MM-DD');
      }
      if (typeof candidate?.toDate === 'function') {
        const parsed = moment(candidate.toDate());
        if (parsed.isValid()) return parsed.tz('Asia/Kolkata').format('YYYY-MM-DD');
      }
    }

    return fallbackDate;
  };

  buildSalesAnalyticsRow = (branch, branchName, orderData, stockEntry, fallbackDate) => {
    const skuCounts = {
      'Mango Summer': 0,
      'Mango Matcha': 0,
      'Mango Passion Iced Tea': 0
    };
    const items = orderData?.items || [];

    items.forEach((item) => {
      const normalizedSku = this.getNormalizedSkuName(item['Item Name']);
      if (!normalizedSku) return;
      const qty = this.getSoldDrinkQuantity(item);
      skuCounts[normalizedSku] += qty;
    });

    const theoreticalKg =
      (skuCounts['Mango Summer'] * SKU_USAGE_KG['Mango Summer']) +
      (skuCounts['Mango Matcha'] * SKU_USAGE_KG['Mango Matcha']) +
      (skuCounts['Mango Passion Iced Tea'] * SKU_USAGE_KG['Mango Passion Iced Tea']);

    const openingStock = stockEntry?.data?.openingStock;
    const closingStock = stockEntry?.data?.closingStock;
    const actualKg =
      typeof openingStock === 'number' && typeof closingStock === 'number'
        ? openingStock - closingStock
        : null;
    const varianceKg = actualKg === null ? null : (actualKg - theoreticalKg);
    const variancePct = actualKg === null || theoreticalKg <= 0 ? null : ((varianceKg / theoreticalKg) * 100);
    const sampleItem = items[0] || null;
    const date = this.getDisplayDateFromOrderItem(sampleItem, fallbackDate);

    return {
      date,
      branch,
      branchName,
      mangoSummerQty: skuCounts['Mango Summer'],
      mangoMatchaQty: skuCounts['Mango Matcha'],
      mangoPassionIcedTeaQty: skuCounts['Mango Passion Iced Tea'],
      theoreticalKg,
      openingStock,
      closingStock,
      actualKg,
      varianceKg,
      variancePct
    };
  };

  loadSalesAnalytics = async () => {
    const { branches, selectedBranch, records } = this.state;
    if (!branches.length) return;

    this.setState({ analyticsLoading: true });
    try {
      const recordDates = Array.from(
        new Set(
          (records || [])
            .map((record) => record?.date || record?.data?.date)
            .filter(Boolean)
        )
      ).sort((a, b) => moment(b).valueOf() - moment(a).valueOf());

      if (!recordDates.length) {
        this.setState({ salesAnalyticsRows: [], analyticsLoading: false });
        return;
      }

      const branchesToLoad = selectedBranch
        ? branches.filter((branch) => branch.value === selectedBranch)
        : branches;

      const stockByDateAndBranch = {};
      (records || []).forEach((record) => {
        const recordDate = record?.date || record?.data?.date;
        if (!recordDate) return;
        stockByDateAndBranch[`${recordDate}__${record.branch}`] = record;
      });

      const rows = [];
      for (const date of recordDates) {
        const { startTime, endTime } = this.getStartAndEndTime(date);
        const branchResponses = await Promise.all(
          branchesToLoad.map(async (branch) => {
            try {
              const orderData = await Client.getGotTeaOrderData(startTime, endTime, [branch.value]);
              return { branch: branch.value, branchName: branch.name, orderData };
            } catch (error) {
              return { branch: branch.value, branchName: branch.name, orderData: { items: [] }, error: true };
            }
          })
        );

        branchResponses.forEach(({ branch, branchName, orderData }) => {
          const stockEntry = stockByDateAndBranch[`${date}__${branch}`];
          rows.push(this.buildSalesAnalyticsRow(branch, branchName, orderData, stockEntry, date));
        });
      }

      rows.sort((a, b) => {
        const dateDiff = moment(b.date).valueOf() - moment(a.date).valueOf();
        if (dateDiff !== 0) return dateDiff;
        return (a.branchName || '').localeCompare(b.branchName || '');
      });

      this.setState({ salesAnalyticsRows: rows, analyticsLoading: false });
    } catch (error) {
      console.error('Failed to load sales analytics', error);
      this.setState({ analyticsLoading: false, salesAnalyticsRows: [] });
    }
  };

  getVarianceLevel = (varianceKg) => {
    if (typeof varianceKg !== 'number') return '';
    if (varianceKg > 0) return 'positive';
    if (varianceKg < 0) return 'negative';
    return 'neutral';
  };

  downloadRowsAsCsv = (rows) => {
    const headers = [
      'Date',
      'Branch',
      'Mango Summer Qty',
      'Mango Matcha Qty',
      'Mango Passion Iced Tea Qty',
      'Theoretical Consumption (kg)',
      'Opening (kg)',
      'Closing (kg)',
      'Actual Consumption (kg)',
      'COGS Variance (kg)',
      'COGS Variance (%)'
    ];

    const escapeCsv = (value) => {
      if (value === null || value === undefined) return '';
      const text = String(value);
      if (text.includes(',') || text.includes('"') || text.includes('\n')) {
        return `"${text.replace(/"/g, '""')}"`;
      }
      return text;
    };

    const body = rows.map((row) => ([
      row.date || '',
      row.branchName || row.branch || '',
      row.mangoSummerQty,
      row.mangoMatchaQty,
      row.mangoPassionIcedTeaQty,
      row.theoreticalKg?.toFixed ? row.theoreticalKg.toFixed(2) : '',
      typeof row.openingStock === 'number' ? row.openingStock.toFixed(2) : '',
      typeof row.closingStock === 'number' ? row.closingStock.toFixed(2) : '',
      typeof row.actualKg === 'number' ? row.actualKg.toFixed(2) : '',
      typeof row.varianceKg === 'number' ? row.varianceKg.toFixed(2) : '',
      typeof row.variancePct === 'number' ? row.variancePct.toFixed(1) : ''
    ].map(escapeCsv).join(',')));

    const csvContent = [headers.join(','), ...body].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', `Mango-Pickle-Sales-Theoretical-All-Days-${moment().format('YYYY-MM-DD')}.csv`);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  };

  exportSalesAnalyticsAllDays = async () => {
    const { branches, selectedBranch, records } = this.state;
    if (!branches.length) return;

    const recordDates = Array.from(
      new Set(
        (records || [])
          .map((record) => record?.date || record?.data?.date)
          .filter(Boolean)
      )
    ).sort((a, b) => moment(a).valueOf() - moment(b).valueOf());

    if (!recordDates.length) {
      alert('No dated stock records found to export.');
      return;
    }

    const branchesToLoad = selectedBranch
      ? branches.filter((branch) => branch.value === selectedBranch)
      : branches;

    const stockByDateAndBranch = {};
    (records || []).forEach((record) => {
      const recordDate = record?.date || record?.data?.date;
      if (!recordDate) return;
      stockByDateAndBranch[`${recordDate}__${record.branch}`] = record;
    });

    this.setState({ exportLoading: true });
    try {
      const exportRows = [];
      for (const date of recordDates) {
        const { startTime, endTime } = this.getStartAndEndTime(date);
        const branchResponses = await Promise.all(
          branchesToLoad.map(async (branch) => {
            try {
              const orderData = await Client.getGotTeaOrderData(startTime, endTime, [branch.value]);
              return { branch: branch.value, branchName: branch.name, orderData };
            } catch (error) {
              return { branch: branch.value, branchName: branch.name, orderData: { items: [] } };
            }
          })
        );

        branchResponses.forEach(({ branch, branchName, orderData }) => {
          const stockEntry = stockByDateAndBranch[`${date}__${branch}`];
          exportRows.push(this.buildSalesAnalyticsRow(branch, branchName, orderData, stockEntry, date));
        });
      }

      exportRows.sort((a, b) => {
        const dateDiff = moment(a.date).valueOf() - moment(b.date).valueOf();
        if (dateDiff !== 0) return dateDiff;
        return (a.branchName || '').localeCompare(b.branchName || '');
      });

      this.downloadRowsAsCsv(exportRows);
    } catch (error) {
      console.error('Failed to export all-days sales analytics', error);
      alert('Could not export CSV. Please try again.');
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  componentDidMount() {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (!user) {
        window.location.href = '/login';
        return;
      }

      try {
        const branches = await this.loadBranches();
        const selectedBranch = this.getStoredBranch(branches);
        this.setState({ branches, selectedBranch, loading: false }, () => {
          this.loadRecords().then(() => this.loadSalesAnalytics());
        });
      } catch (error) {
        console.error('Failed to load branch list', error);
        this.setState({ loading: false });
      }
    });
  }

  resetForm = () => {
    this.setState({
      stockDate: moment.tz(moment(), 'Asia/Kolkata').format('YYYY-MM-DD'),
      openingStock: '',
      closingStock: '',
      unit: 'kg',
      editingRecordId: null,
      formWarning: ''
    });
  };

  handleBranchChange = (selectedOption) => {
    const nextBranch = selectedOption?.value || '';
    if (nextBranch) {
      localStorage.setItem(BRANCH_STORAGE_KEY, nextBranch);
    } else {
      localStorage.removeItem(BRANCH_STORAGE_KEY);
    }
    this.setState({ selectedBranch: nextBranch }, () => {
      this.prefillExistingEntry(nextBranch, this.state.stockDate);
      this.loadSalesAnalytics(this.state.stockDate);
    });
  };

  prefillExistingEntry = (branch = this.state.selectedBranch, date = this.state.stockDate) => {
    if (!branch || !date) return;

    const records = this.state.records || [];
    const matchingRecord = records.find((record) => {
      const recordDate = record?.date || record?.data?.date;
      return record.branch === branch && recordDate === date;
    });

    if (!matchingRecord) {
      this.setState({
        openingStock: '',
        closingStock: '',
        editingRecordId: null,
        formWarning: ''
      });
      return;
    }

    const data = matchingRecord?.data || {};
    this.setState({
      editingRecordId: matchingRecord.id,
      openingStock: typeof data.openingStock === 'number' ? data.openingStock.toString() : '',
      closingStock: typeof data.closingStock === 'number' ? data.closingStock.toString() : '',
      formWarning: ''
    });
  };

  validateForm = () => {
    const { selectedBranch, openingStock, closingStock, unit } = this.state;
    const hasOpeningStock = !Utilities.isNullOrEmpty(openingStock);
    const hasClosingStock = !Utilities.isNullOrEmpty(closingStock);
    if (!selectedBranch) return 'Please select a branch first.';
    if (!hasOpeningStock && !hasClosingStock) return 'Enter opening stock.';
    if (!hasOpeningStock && hasClosingStock) return 'Opening stock is required before closing stock.';
    if (hasOpeningStock && isNaN(parseFloat(openingStock))) return 'Opening stock must be a valid number.';
    if (hasClosingStock && isNaN(parseFloat(closingStock))) return 'Closing stock must be a valid number.';
    if (unit !== 'kg') return 'Unit must be kg.';
    return null;
  };

  saveEntry = async () => {
    const validationError = this.validateForm();
    if (validationError) {
      this.setState({ formWarning: validationError });
      return;
    }

    const { selectedBranch, stockDate, openingStock, closingStock, unit, editingRecordId } = this.state;
    const openingStockValue = Utilities.isNullOrEmpty(openingStock) ? null : parseFloat(openingStock);
    const closingStockValue = Utilities.isNullOrEmpty(closingStock) ? null : parseFloat(closingStock);
    if ((openingStockValue !== null && openingStockValue > 150) || (closingStockValue !== null && closingStockValue > 150)) {
      this.setState({
        formWarning: 'Blocking warning: Unit is in kg (not grams). Values above 150 are not allowed. Please use values like 0.1 instead of 100.'
      });
      return;
    }
    this.setState({ formWarning: '' });
    const actionPayload = {
      actionType: 'mangoPickleStockEntry',
      branch: selectedBranch,
      status: 'Recorded',
      date: stockDate,
      data: {
        date: stockDate,
        item: FIXED_ITEM_NAME,
        openingStock: openingStockValue,
        closingStock: closingStockValue,
        unit
      }
    };

    this.setState({ saving: true });
    try {
      if (editingRecordId) {
        await Client.updateAction(editingRecordId, actionPayload);
      } else {
        await Client.createNewAction(actionPayload);
      }
      this.resetForm();
      await this.loadRecords();
      await this.loadSalesAnalytics(stockDate);
    } catch (error) {
      console.error('Failed to save stock entry', error);
      alert('Could not save entry. Please try again.');
    } finally {
      this.setState({ saving: false });
    }
  };

  startEditRecord = (record) => {
    const data = record?.data || {};
    this.setState({
      editingRecordId: record.id,
      selectedBranch: record.branch || '',
      stockDate: record.date || data.date || moment.tz(moment(), 'Asia/Kolkata').format('YYYY-MM-DD'),
      openingStock: data.openingStock?.toString?.() || '',
      closingStock: data.closingStock?.toString?.() || '',
      unit: 'kg'
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  getVisibleRecords = () => {
    const { records, selectedBranch } = this.state;
    if (!selectedBranch) return records;
    return records.filter((record) => record.branch === selectedBranch);
  };

  renderRecordsTable = () => {
    const records = this.getVisibleRecords();
    if (!records.length) {
      return <p className="mps-empty-state">No stock entries saved yet.</p>;
    }

    return (
      <React.Fragment>
      <TableContainer className="mps-desktop-table" component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Branch</TableCell>
              <TableCell>Item</TableCell>
              <TableCell>Opening</TableCell>
              <TableCell>Closing</TableCell>
              <TableCell>Unit</TableCell>
              <TableCell align="center">Edit</TableCell>
              <TableCell align="center">Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {records.map((record) => {
              const data = record?.data || {};
              return (
                <TableRow key={record.id}>
                  <TableCell>{record.date || data.date || '-'}</TableCell>
                  <TableCell>{record.branch || '-'}</TableCell>
                  <TableCell>{data.item || FIXED_ITEM_NAME}</TableCell>
                  <TableCell>{data.openingStock ?? '-'}</TableCell>
                  <TableCell>{data.closingStock ?? '-'}</TableCell>
                  <TableCell>{data.unit || '-'}</TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" onClick={() => this.startEditRecord(record)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton color="error" onClick={() => this.deleteRecord(record)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="mps-mobile-card-list">
        {records.map((record) => {
          const data = record?.data || {};
          return (
            <div className="mps-mobile-card" key={`mobile-record-${record.id}`}>
              <div className="mps-mobile-card-title">
                <strong>{record.branch || '-'}</strong>
                <span>{record.date || data.date || '-'}</span>
              </div>
              <div className="mps-mobile-metrics">
                <span><label>Item</label>{data.item || FIXED_ITEM_NAME}</span>
                <span><label>Opening</label>{typeof data.openingStock === 'number' ? `${data.openingStock} kg` : '-'}</span>
                <span><label>Closing</label>{typeof data.closingStock === 'number' ? `${data.closingStock} kg` : '-'}</span>
              </div>
              <div className="mps-mobile-actions">
                <IconButton color="primary" onClick={() => this.startEditRecord(record)} size="small">
                  <EditIcon />
                </IconButton>
                <IconButton color="error" onClick={() => this.deleteRecord(record)} size="small">
                  <DeleteIcon />
                </IconButton>
              </div>
            </div>
          );
        })}
      </div>
      </React.Fragment>
    );
  };

  render() {
    const {
      loading,
      saving,
      recordsLoading,
      analyticsLoading,
      exportLoading,
      branches,
      selectedBranch,
      stockDate,
      openingStock,
      closingStock,
      editingRecordId,
      salesAnalyticsRows,
      formWarning
    } = this.state;
    const branchOptions = [ALL_BRANCH_OPTION, ...branches];
    const selectedBranchOption = selectedBranch
      ? branches.find((branch) => branch.value === selectedBranch) || ALL_BRANCH_OPTION
      : ALL_BRANCH_OPTION;

    return (
      <React.Fragment>
        <ReportsHeader />
        <div className="mangoPickleStockContainer">
          <div className="mps-card mps-branch-filter-card">
            <Autocomplete
              options={branchOptions}
              value={selectedBranchOption}
              getOptionLabel={(option) => option?.name || ''}
              isOptionEqualToValue={(option, value) => option?.value === value?.value}
              onChange={(_, selectedOption) => this.handleBranchChange(selectedOption)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Branch Selector"
                  size="small"
                  placeholder="Type branch name/code"
                />
              )}
            />
          </div>

          <div className="mps-card">
            <h2>Mango Pickle Daily Stock</h2>
            {loading ? (
              <Loader />
            ) : (
              <React.Fragment>
                <div className="mps-form-row mps-date-row">
                  <TextField
                    type="date"
                    size="small"
                    label="Date"
                    InputLabelProps={{ shrink: true }}
                    value={stockDate}
                    onChange={(e) => {
                      const nextDate = e?.target?.value;
                      if (!nextDate) return;
                      this.setState({ stockDate: nextDate }, () => {
                        this.prefillExistingEntry(this.state.selectedBranch, nextDate);
                        this.loadSalesAnalytics(nextDate);
                      });
                    }}
                  />
                </div>

                <div className="mps-single-item">
                  <TextField label="Item" size="small" value={FIXED_ITEM_NAME} InputProps={{ readOnly: true }} />
                  <TextField
                    label="Opening Stock"
                    size="small"
                    type="number"
                    value={openingStock}
                    onChange={(e) => this.setState({ openingStock: e.target.value })}
                    placeholder="0"
                  />
                  <TextField
                    label="Closing Stock"
                    size="small"
                    type="number"
                    value={closingStock}
                    onChange={(e) => this.setState({ closingStock: e.target.value })}
                    placeholder="0"
                  />
                  <TextField label="Unit" size="small" value="kg" InputProps={{ readOnly: true }} />
                </div>
                {formWarning ? <p className="mps-warning-text">{formWarning}</p> : null}

                <div className="mps-actions-row">
                  <div />
                  <div className="mps-right-actions">
                    {editingRecordId && (
                      <Button variant="text" color="inherit" onClick={this.resetForm}>
                        Cancel Edit
                      </Button>
                    )}
                    <Button
                      startIcon={<SaveIcon />}
                      variant="contained"
                      onClick={this.saveEntry}
                      disabled={saving}
                    >
                      {editingRecordId ? 'Update Entry' : 'Save Entry'}
                    </Button>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>

          <div className="mps-card">
            <div className="mps-card-header">
              <h2>Sales & Theoretical Consumption (All Days)</h2>
              <div className="mps-right-actions">
                <Button
                  size="small"
                  startIcon={<DownloadIcon />}
                  variant="outlined"
                  onClick={this.exportSalesAnalyticsAllDays}
                  disabled={analyticsLoading || exportLoading}
                >
                  {exportLoading ? 'Exporting...' : 'Export CSV (All Days)'}
                </Button>
                <Button
                  size="small"
                  startIcon={<RefreshIcon />}
                  variant="outlined"
                  onClick={() => this.loadSalesAnalytics()}
                  disabled={analyticsLoading || exportLoading}
                >
                  Refresh
                </Button>
              </div>
            </div>
            <p className="mps-help-text">
              Usage factors (kg/unit): Mango Summer 0.12, Mango Matcha 0.11, Mango Passion Iced Tea 0.08
            </p>
            {analyticsLoading ? (
              <Loader />
            ) : (
              <React.Fragment>
              <TableContainer className="mps-desktop-table" component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Branch</TableCell>
                      <TableCell align="right">Mango Summer Qty</TableCell>
                      <TableCell align="right">Mango Matcha Qty</TableCell>
                      <TableCell align="right">Mango Passion Iced Tea Qty</TableCell>
                      <TableCell align="right">Theoretical Consumption (kg)</TableCell>
                      <TableCell align="right">Opening (kg)</TableCell>
                      <TableCell align="right">Closing (kg)</TableCell>
                      <TableCell align="right">Actual Consumption (kg)</TableCell>
                      <TableCell align="right">COGS Variance (kg)</TableCell>
                      <TableCell align="right">COGS Variance (%)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {salesAnalyticsRows.map((row) => {
                      const varianceLevel = this.getVarianceLevel(row.varianceKg);
                      return (
                      <TableRow key={`sales-${row.date}-${row.branch}`} className={varianceLevel ? `mps-variance-row-${varianceLevel}` : ''}>
                        <TableCell>{row.date || '-'}</TableCell>
                        <TableCell>{row.branchName}</TableCell>
                        <TableCell align="right">{row.mangoSummerQty}</TableCell>
                        <TableCell align="right">{row.mangoMatchaQty}</TableCell>
                        <TableCell align="right">{row.mangoPassionIcedTeaQty}</TableCell>
                        <TableCell align="right">{row.theoreticalKg.toFixed(2)}</TableCell>
                        <TableCell align="right">{typeof row.openingStock === 'number' ? row.openingStock.toFixed(2) : '-'}</TableCell>
                        <TableCell align="right">{typeof row.closingStock === 'number' ? row.closingStock.toFixed(2) : '-'}</TableCell>
                        <TableCell align="right">{typeof row.actualKg === 'number' ? row.actualKg.toFixed(2) : '-'}</TableCell>
                        <TableCell align="right" className={varianceLevel ? `mps-variance-cell-${varianceLevel}` : ''}>
                          {typeof row.varianceKg === 'number' ? row.varianceKg.toFixed(2) : '-'}
                        </TableCell>
                        <TableCell align="right" className={varianceLevel ? `mps-variance-cell-${varianceLevel}` : ''}>
                          {typeof row.variancePct === 'number' ? `${row.variancePct.toFixed(1)}%` : '-'}
                        </TableCell>
                      </TableRow>
                    )})}
                    {salesAnalyticsRows.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={11} align="center">No data available for recorded dates.</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="mps-mobile-card-list">
                {salesAnalyticsRows.map((row) => {
                  const varianceLevel = this.getVarianceLevel(row.varianceKg);
                  return (
                    <div className={`mps-mobile-card ${varianceLevel ? `mps-mobile-card-${varianceLevel}` : ''}`} key={`mobile-sales-${row.date}-${row.branch}`}>
                      <div className="mps-mobile-card-title">
                        <strong>{row.branchName}</strong>
                        <span>{row.date || '-'}</span>
                      </div>
                      <div className="mps-mobile-metrics">
                        <span><label>Mango Summer</label>{row.mangoSummerQty}</span>
                        <span><label>Mango Matcha</label>{row.mangoMatchaQty}</span>
                        <span><label>Mango Passion Iced Tea</label>{row.mangoPassionIcedTeaQty}</span>
                        <span><label>Theoretical</label>{row.theoreticalKg.toFixed(2)} kg</span>
                        <span><label>Opening</label>{typeof row.openingStock === 'number' ? `${row.openingStock.toFixed(2)} kg` : '-'}</span>
                        <span><label>Closing</label>{typeof row.closingStock === 'number' ? `${row.closingStock.toFixed(2)} kg` : '-'}</span>
                        <span><label>Actual</label>{typeof row.actualKg === 'number' ? `${row.actualKg.toFixed(2)} kg` : '-'}</span>
                        <span className={varianceLevel ? `mps-mobile-variance-${varianceLevel}` : ''}>
                          <label>Variance</label>
                          {typeof row.varianceKg === 'number' ? `${row.varianceKg.toFixed(2)} kg` : '-'}
                        </span>
                        <span className={varianceLevel ? `mps-mobile-variance-${varianceLevel}` : ''}>
                          <label>Variance %</label>
                          {typeof row.variancePct === 'number' ? `${row.variancePct.toFixed(1)}%` : '-'}
                        </span>
                      </div>
                    </div>
                  );
                })}
                {salesAnalyticsRows.length === 0 && (
                  <p className="mps-empty-state">No data available for recorded dates.</p>
                )}
              </div>
              </React.Fragment>
            )}
          </div>

          <div className="mps-card">
            <h2>Bulk Edit Dashboard</h2>
            {recordsLoading ? <Loader /> : this.renderRecordsTable()}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MangoPickleStock;
